import { style } from '@vanilla-extract/css';
import { ENTRANCE_EXPRESSIVE_EASING, SLOW_01_DURATION, MODERATE_02_DURATION } from '@/utils/motion';

export const gaugeContainer = style(
  {
    position: 'relative',
    flexShrink: 0,
  },
  'gauge-container',
);

export const gaugeLabel = style(
  {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  'gauge-label',
);

export const gaugeArc = style(
  {
    transition: `stroke-dashoffset ${SLOW_01_DURATION}s cubic-bezier(${ENTRANCE_EXPRESSIVE_EASING}), stroke ${MODERATE_02_DURATION}s cubic-bezier(${ENTRANCE_EXPRESSIVE_EASING})`,
    '@media': {
      '(prefers-reduced-motion: reduce)': {
        transition: 'none',
      },
    },
  },
  'gauge-arc',
);

export const gaugeTrack = style(
  {
    transition: `stroke ${MODERATE_02_DURATION}s cubic-bezier(${ENTRANCE_EXPRESSIVE_EASING})`,
    '@media': {
      '(prefers-reduced-motion: reduce)': {
        transition: 'none',
      },
    },
  },
  'gauge-track',
);
